
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy/[slug]",
      function () {
        return require("private-next-pages/privacy/[slug].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy/[slug]"])
      });
    }
  